import { apiClient } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import type { TokenOperationItem } from "@/types/api/tokenOperation";
import type { OrganizationTypeValue } from "@/types/domain";
import { useApiTransactionMutation } from "./useApiTransactionMutation";

type CreateOffRampPayload = {
  externalEntityId: string;
  externalEntityType: Exclude<OrganizationTypeValue, "PLATFORM">;
  amount: number;
  requestId: string;
  /** Used for cache invalidation only; not sent to the API. */
  publicKey?: string;
};

export function useCreateOffRamp() {
  return useApiTransactionMutation<CreateOffRampPayload, TokenOperationItem>(
    ({ externalEntityId, externalEntityType, amount, requestId }) =>
      apiClient.postData<TokenOperationItem>("/token-operations/off-ramp", {
        externalEntityId,
        externalEntityType,
        amount,
        requestId,
      }),
    ({ publicKey }) => [
      { queryKey: queryKeys.tokenOperations.lists(), refetchType: "all" },
      publicKey ? { queryKey: queryKeys.blockchain.balance(publicKey) } : undefined,
    ],
  );
}
